export class KilledGameRenderer {

  constructor(map) {
    this.map = map;
    this.markers = [];
  }

  render(killedGameData) {
    // Clear existing markers
    this.clear();

    if (!killedGameData || killedGameData.length === 0) {
      return;
    }

    // Add markers for each killed game location
    killedGameData.forEach((location) => {
      this.addMarker(location);
    });

    // Fit bounds to show all markers
    this.fitBounds();
  }

  addMarker(location) {
    // Custom icon for killed game - green if collected, blue otherwise
    const markerColor = location.collected ? '#2fb344' : '#c42020ff';
    const killedGameIcon = L.divIcon({
      className: 'custom-map-marker',
      html: `
        <div style="
          width: 32px;
          height: 32px;
          background-color: ${markerColor};
          border: 3px solid white;
          border-radius: 50%;
          box-shadow: 0 2px 4px rgba(0,0,0,0.3);
          display: flex;
          align-items: center;
          justify-content: center;
        ">
          <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="white"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 3c0 2 1 3 4 3c2 0 3 1 3 3" /><path d="M21 3c0 2 -1 3 -4 3c-2 0 -3 .333 -3 3" />
            <path d="M12 18c-1 0 -4 -3 -4 -6c0 -2 1.333 -3 4 -3s4 1 4 3c0 3 -3 6 -4 6" /><path d="M15.185 14.889l.095 -.18a4 4 0 1 1 -6.56 0" /><path d="M17 3c0 1.333 -.333 2.333 -1 3" />
            <path d="M7 3c0 1.333 .333 2.333 1 3" /><path d="M7 6c-2.667 .667 -4.333 1.667 -5 3" /><path d="M17 6c2.667 .667 4.333 1.667 5 3" />
            <path d="M8.5 10l-1.5 -1" /><path d="M15.5 10l1.5 -1" /><path d="M12 15h.01" />
          </svg>
        </div>
      `,
      iconSize: [32, 32],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32]
    });

    // Build popup content with collected status
    let popupContent = `
      <div style="text-align: center; background: white; padding: 8px;">
        <strong>${location.type}</strong><br>
        <span class="badge bg-dark text-white">${location.quantity}x</span><br>`;
    
    if (location.collected) {
      popupContent += `<span class="badge bg-success text-white" style="margin-top: 4px;">Prikupljeno</span><br>`;
      if (location.collected_by) {
        popupContent += `<small class="text-muted">${location.collected_by}</small><br>`;
      }
    } else {
      popupContent += `<span class="badge bg-danger text-white" style="margin-top: 4px;">Nije prikupljeno</span><br>`;
    }
    
    popupContent += `
      <small class="text-muted">${location.lat.toFixed(6)}, ${location.lng.toFixed(6)}</small>
    `;
    
    // Add collect button if user can edit and game is not collected
    if (location.can_edit && !location.collected) {
      popupContent += `
        <br>
        <button 
          class="btn btn-sm btn-outline-success mt-2" 
          data-killed-game-id="${location.id}"
          data-club-id="${location.club_id}"
          data-hunting-log-id="${location.hunting_log_id}">
          Označi kao prikupljeno
        </button>
      `;
    }
    
    popupContent += `</div>`;

    const marker = L.marker([location.lat, location.lng], { icon: killedGameIcon })
      .addTo(this.map)
      .bindPopup(popupContent);
    
    // Add click handler after popup is added
    marker.on('popupopen', () => {
      const button = document.querySelector(`button[data-killed-game-id="${location.id}"]`);
      if (button) {
        button.addEventListener('click', () => this.toggleCollected(location, marker));
      }
    });
    
    this.markers.push(marker);
  }

  async toggleCollected(location, marker) {
    try {
      const response = await fetch(`/clubs/${location.club_id}/hunting_logs/${location.hunting_log_id}/killed_game/${location.id}/toggle_collected`, {
        method: 'PATCH',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Accept': 'application/json'
        }
      });

      if (response.ok) {
        // Update location data
        location.collected = true;
        location.collected_by = 'Prikupljeno'; // You might want to get the actual user name from response
        
        // Close the popup
        marker.closePopup();
        
        // Remove old marker
        this.map.removeLayer(marker);
        const index = this.markers.indexOf(marker);
        if (index > -1) {
          this.markers.splice(index, 1);
        }
        
        // Add updated marker
        this.addMarker(location);
      }
    } catch (error) {
      console.error('Failed to toggle collected status:', error);
    }
  }

  fitBounds() {
    if (this.markers.length > 0) {
      const group = L.featureGroup(this.markers);
      this.map.fitBounds(group.getBounds().pad(0.1));
    }
  }

  clear() {
    this.markers.forEach(marker => {
      this.map.removeLayer(marker);
    });
    this.markers = [];
  }

  show() {
    this.markers.forEach(marker => {
      marker.addTo(this.map);
    });
  }

  hide() {
    this.markers.forEach(marker => {
      this.map.removeLayer(marker);
    });
  }
}
